import { render, staticRenderFns } from "./OnboardingWizardView.vue?vue&type=template&id=667b4fa1&scoped=true"
import script from "./OnboardingWizardView.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingWizardView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OnboardingWizardView.vue?vue&type=style&index=0&id=667b4fa1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667b4fa1",
  null
  
)

export default component.exports